import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { WebsiteEnquiry } from '@contracts/interfaces/website-enquiry.interface';

interface WebsiteEnquiryDetailData {
  enquiry: WebsiteEnquiry;
  activeTab: string;
  mayBeSpam: boolean | null;
  rawSubmittedData: string;
  isMakingTask: boolean;
}

@Component({
  selector: 'app-website-enquiry-detail-dialog',
  templateUrl: './website-enquiry-detail.dialog.html',
  styleUrls: ['./website-enquiry-detail.dialog.scss']
})
export class WebsiteEnquiryDetailDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<WebsiteEnquiryDetailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: WebsiteEnquiryDetailData
  ) {}

  get enquiry(): WebsiteEnquiry {
    return this.data.enquiry;
  }

  get isArchived(): boolean {
    return this.data.activeTab === 'archived';
  }

  get contactName(): string {
    return this.enquiry?.name || 'No name';
  }

  get emailHref(): string {
    return `mailto:${this.enquiry?.email || ''}`;
  }

  close(action?: 'make-task' | 'archive' | 'restore') {
    this.dialogRef.close(action ? { action } : undefined);
  }
}
